export const MARKDOWN_CONTENT_TYPE = "text/markdown";
export const MARKDOWN_CONTENT_TYPE_ALIAS = "text/x-markdown";
export const MARKDOWN_EXTENSIONS = [".md", ".markdown"];

function getFileExtension(filename: string): string {
    const lastDotIndex = filename.lastIndexOf(".");
    return lastDotIndex === -1 ? "" : filename.slice(lastDotIndex).toLowerCase();
}

export function normalizeMarkdownFiles(files: File[], supportedContentTypes: readonly string[]): File[] {
    const supportedTypes = new Set(supportedContentTypes);

    return files.map((file) => {
        const contentType = file.type === MARKDOWN_CONTENT_TYPE_ALIAS ? MARKDOWN_CONTENT_TYPE : file.type;
        if (contentType === MARKDOWN_CONTENT_TYPE) {
            return file.type === contentType ? file : new File([file], file.name, { type: contentType, lastModified: file.lastModified });
        }
        if (!supportedTypes.has(contentType) && MARKDOWN_EXTENSIONS.includes(getFileExtension(file.name))) {
            return new File([file], file.name, { type: MARKDOWN_CONTENT_TYPE, lastModified: file.lastModified });
        }
        return file;
    });
}
